import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Accordion, Table } from "react-bootstrap";
import bannerImage from "../../Images/academic/mous-banner.webp";
import logo from "../../Images/logo/isbm-university.webp";
import digitoald from "../../Images/MOU/Digitoald.webp";
import digitoaldthumb from "../../Images/MOU/Digitoadimg.webp";
import GULogo from "../../Images/MOU/GU-Logo.webp";
import GUThumb from "../../Images/MOU/GU-thumb.webp";
import aryaLogo from "../../Images/MOU/arya-Logo.webp";
import aryaThumb from "../../Images/MOU/arya-thumb.webp";
import AudyogikLogo from "../../Images/MOU/Audyogik-logo.webp";
import AudyogikThumb from "../../Images/MOU/Audyogik-thumb.webp";
import diuLogo from "../../Images/MOU/diu-logo.webp";
import diuThumb from "../../Images/MOU/diu-thumb.webp";
import internzlearnLogo from "../../Images/MOU/internzlearn-logo.webp";
import internzlearnThumb from "../../Images/MOU/internzlearn-thumb.webp";
import ksrLogo from "../../Images/MOU/ksr-logo.webp";
import ksrThumb from "../../Images/MOU/ksr-thumb.webp";
import GIPERLogo from "../../Images/MOU/GIPER-logo.webp";
import GIPERThumb from "../../Images/MOU/GIPER-thumb.webp";
import ChitkaraLogo from "../../Images/MOU/Chitkara-logo.webp";
import ChitkaraThumb from "../../Images/MOU/Chitkara-thumb.webp";
import INSDLogo from "../../Images/MOU/INSD-logo.webp";
import INSDThumb from "../../Images/MOU/INSD-thumb.webp";
import MaharajaLogo from "../../Images/MOU/Maharaja-logo.webp";
import MaharajaThumb from "../../Images/MOU/Maharaja-thumb.webp";
import MaharajaThumb2 from "../../Images/MOU/Maharaja-thumb2.webp";
import MaharishiLogo from "../../Images/MOU/Maharishi-logo.webp";
import MaharishiThumb from "../../Images/MOU/Maharishi-thumb.webp";
import MaharishiThumb2 from "../../Images/MOU/Maharishi-thumb2.webp";
import SAMLogo from "../../Images/MOU/SAM-logo.webp";
import SAMThumb from "../../Images/MOU/SAM-thumb.webp";
import SAMThumb2 from "../../Images/MOU/SAM-thumb2.webp";
import ModernLogo from "../../Images/MOU/Modern-logo.webp";
import ModernThumb from "../../Images/MOU/Modern-thumb.webp";
import SushantLogo from "../../Images/MOU/Sushant-logo.webp";
import SushantThumb from "../../Images/MOU/Sushant-thumb.webp";
import ShobitLogo from "../../Images/MOU/Shobit-logo.webp";
import ShobitThumb from "../../Images/MOU/Shobit-thumb.webp";
import TruscholarLogo from "../../Images/MOU/TruScholar-logo.webp";
import TruscholarThumb from "../../Images/MOU/Truscholar-thumb.webp";
import TruscholarThumb2 from "../../Images/MOU/Truscholar-thumb2.webp";
import USTMLogo from "../../Images/MOU/USTM-logo.webp";
import USTMThumb from "../../Images/MOU/USTM-thumb.webp";
import FundCorpsLogo from "../../Images/MOU/FundCorps-logo.webp";
import FundCorpsThumb from "../../Images/MOU/FundCorps-thumb.webp";
import SriSriLogo from "../../Images/MOU/SriSri-logo.webp";
import SriSriThumb from "../../Images/MOU/SirSir-thumb.webp";
import SriSriThumb2 from "../../Images/MOU/SirSir-thumb2.webp";
import CybermotionLogo from "../../Images/MOU/Cybermotion-logo.webp";
import CybermotionThumb from "../../Images/MOU/Cybermotion-thumb.webp";
import rushfordLogo from "../../Images/MOU/rushford-logo.webp";
import rushfordThumb from "../../Images/MOU/rushford-thumb.webp";
import henryLogo from "../../Images/MOU/henry-logo.webp";
import henryThumb from "../../Images/MOU/henry-thumb.webp";
import ShriRamLogo from "../../Images/MOU/ShriRam-logo.webp";
import ShriRamThumb from "../../Images/MOU/ShriRam-thumb.webp";
import NIMSThumb from "../../Images/MOU/ShriRam-thumb.webp";
import NIMSLogo from "../../Images/MOU/Nims-logo.webp";
import RVSThumb from "../../Images/MOU/RVS-thumb.webp";
import RVSLogo from "../../Images/MOU/RVS-logo.webp";
import KsRangaThumb from "../../Images/MOU/KsRangaA&S-thumb.webp";
import KsRnagaLogo from "../../Images/MOU/KsRanga-logo.webp";
import LNCTThumb from "../../Images/MOU/LNCT-thumb.webp";
import LNCTLogo from "../../Images/MOU/LNCT-logo.webp";
import JNCTThumb from "../../Images/MOU/JNCT-thumb.webp";
import JNCTLogo from "../../Images/MOU/JNCT-logo.webp";
import KsRnagaASThumb from "../../Images/MOU/KsRangaA&S-thumb.webp";
import KsRnagaASLogo from "../../Images/MOU/KsRangaA&S-logo.webp";
import ElecThumb from "../../Images/MOU/Elec-thumb.webp";
import ElecLogo from "../../Images/MOU/Elec-logo.webp";
import ImageThumb from "../../Images/MOU/Image-thumb.webp";
import ImageLogo from "../../Images/MOU/Image-logo.webp";
import DyPatilThumb from "../../Images/MOU/DyPatil-thumb.webp";
import DyPatilLogo from "../../Images/MOU/DyPatil-logo.webp";
import ASSAMThumb from "../../Images/MOU/ASSAM-thumb.webp";
import ASSAMLogo from "../../Images/MOU/ASSAM-logo.webp";
import BharitiyaThumb from "../../Images/MOU/Bharitiya-thumb.webp";
import BharitiyaLogo from "../../Images/MOU/Bharirtiya-logo.webp";
import AjeeThumb from "../../Images/MOU/Ajee-thumb.webp";
import AjeeLogo from "../../Images/MOU/Ajee-logo.webp";
import AKSThumb from "../../Images/MOU/AKS-thumb.webp";
import AKSLogo from "../../Images/MOU/AKS-logo.webp";
import AryaThumb1 from "../../Images/MOU/Arya-thumb1.webp";
import AryaLogo from "../../Images/MOU/arya-Logo.webp";
import ASDCThumb from "../../Images/MOU/ASDC-thumb.webp";
import ASDCLogo from "../../Images/MOU/ASDC-logo.webp";
import IBBULogo from "../../Images/MOU/ibbu-logo.png";
import IBBUThumb from "../../Images/MOU/ibbu-thumb.png";
import TriedgeLogo from "../../Images/MOU/triedge-logo.png";
import Triedge from "../../Images/MOU/triedge-thumb.png"
import { Link } from "react-router-dom";

const mouList = [
  {
    partnerName: "",
    partnerLogo: TriedgeLogo,
    partnerThumb: Triedge,
    description: `This Memorandum of Understanding (“MoU”) is made and entered into on this 31<sup>st</sup> day of July, 2026 (the “Effective Date”), by and between Triedge Solutions Private Ltd., having its registered office at T19 503, Commonwealth Games Village, Delhi 110092, hereinafter referred to as “triedge.in” and ISBM University, located at Chhattisgarh, hereinafter referred to as the “Institution”. triedge.in and the Institution shall collectively be referred to as the “Parties.”`,
  },
  {
    partnerName: "Ibrahim Badamasi Babangida University",
    partnerLogo: IBBULogo,
    partnerThumb: IBBUThumb,
    description: `ISBM University has signed a Memorandum of Understanding (MoU) with Ibrahim Badamasi Babangida University (IBBU), Lapai, Nigeria, to strengthen academic collaboration, research, innovation, and global knowledge exchange. The partnership aims to promote faculty and student exchange programs, joint research initiatives, curriculum development, academic conferences, and collaborative learning opportunities. This MoU provides students and faculty of both universities with enhanced international exposure, research collaboration, and opportunities for academic and professional growth.`,
  },
  {
    partnerName: "DigiToad Technologies",
    partnerLogo: digitoald,
    partnerThumb: digitoaldthumb,
    description: `ISBM University signed an MoU with DigiToad Technologies Pvt. Ltd., a Bangalore‑based firm which specializes in Embedded Systems and Engineering solutions with a focus on AI and ML. The objective of the agreement is to bring industry interface to Engineering and Management students of ISBM University. The MoU will also enable students secure industry internships and training in the field.`,
  },
  {
    partnerName: "DIU Institute of Engineering & Technology",
    partnerLogo: diuLogo,
    partnerThumb: diuThumb,
    description: `DIU Institute of Engineering & Technology (DIET) is amongst the foremost of Top Institutes in Rajasthan for Engineering in Higher Technical Education & Research. Established in 2005, the institute has evolved into one of Jaipur’s best engineering colleges.`,
  },
  {
    partnerName: "Internzlearn Institute of Engineering & Technology",
    partnerLogo: internzlearnLogo,
    partnerThumb: internzlearnThumb,
    description: `Internzlearn Institute of Engineering & Technology (IIET) is amongst the foremost of Top Institutes in Rajasthan for Engineering in Higher Technical Education & Research. Established in 2005, the institute has evolved into one of Jaipur’s best engineering colleges.`,
  },
  {
    partnerName: "KSR Institute of Engineering & Technology",
    partnerLogo: ksrLogo,
    partnerThumb: ksrThumb,
    description: `KSR Institute of Engineering & Technology (KIET) is amongst the foremost of Top Institutes in Rajasthan for Engineering in Higher Technical Education & Research. Established in 2005, the institute has evolved into one of Jaipur’s best engineering colleges.`,
  },
  {
    partnerName: "Arya Institute of Engineering & Technology (AIET)",
    partnerLogo: aryaLogo,
    partnerThumb: aryaThumb,
    description: `Arya Institute of Engineering & Technology (AIET) is amongst the foremost of Top Institutes in Rajasthan for Engineering in Higher Technical Education & Research. Established in 2005, the institute has evolved into one of Jaipur’s best engineering colleges.`,
  },
  {
    partnerName: "Geeta University",
    partnerLogo: GULogo,
    partnerThumb: GUThumb,
    description: `Geeta University is part of the Geeta Group of Institutions, an educational hub since 1985. It offers a runway for thousands of dreams with expertise, experience, and excellence.`,
  },
  {
    partnerName: "Audyogik",
    partnerLogo: AudyogikLogo,
    partnerThumb: AudyogikThumb,
    description: `Pioneers in management education in Pimpri‑Chinchwad, Audyogik (ASM’s IBMR) is the first institute in Maharashtra with AICTE approval, affiliated to Savitribai Phule Pune University and approved by the HRD Ministry.`,
  },
  {
    partnerName: "Global Institute of Pharmaceutical Education and Research",
    partnerLogo: GIPERLogo,
    partnerThumb: GIPERThumb,
    description: `GIPER Kashipur, established in 2009, is a premier institution in pharmaceutical sciences to meet societal needs and make India a world leader in pharmaceutical education.`,
  },
  {
    partnerName: "Chitkara University",
    partnerLogo: ChitkaraLogo,
    partnerThumb: ChitkaraThumb,
    description: `Chitkara University offers industry-endorsed programs, outstanding faculty, and state-of-the-art facilities. It provides unlimited placement opportunities across its 1500+ strong network.`,
  },
  {
    partnerName: "INSD (International School of Design)",
    partnerLogo: INSDLogo,
    partnerThumb: INSDThumb,
    description: `INSD pioneers design education in India, bridging the gap between academics and industry. It focuses on nurturing talent, innovation, and potential among youth.`,
  },
  {
    partnerName: "Maharaja Agrasen Himalayan Garhwal University (MAHGU)",
    partnerLogo: MaharajaLogo,
    partnerThumb: MaharajaThumb,
    description: `MAHGU was established under Uttarakhand Act No. 33 of 2016 and recognized under UGC Section 2(f). It aims to provide quality higher education in the Himalayan region.`,
  },
  // {
  //   partnerName: "Maharaja Agrasen Himalayan Garhwal University (MAHGU)",
  //   partnerLogo: MaharajaLogo,
  //   partnerThumb: MaharajaThumb2,
  //   description: `Maharaja Agrasen Himalayan Garhwal University (MAHGU) is established and incorporated by Government of Uttarakhand Act No. 33 of 2016.`,
  // },
  {
    partnerName: "Maharishi Mahesh Yogi Vedic Vishwavidyalaya (MMYVV)",
    partnerLogo: MaharishiLogo,
    partnerThumb: MaharishiThumb,
    description: `MMYVV was established under Madhya Pradesh Act No. 37 of 1995. Based in Karaundi, Katni, MP, it is reputed for disseminating quality Vedic-based education.`,
  },
  // {
  //   partnerName: "Maharishi Mahesh Yogi Vedic Vishwavidyalaya (MMYVV)",
  //   partnerLogo: MaharishiLogo,
  //   partnerThumb: MaharishiThumb2,
  //   description: `The MOU has a huge significance for us, and I am highly delighted to you that you have the same potential of working in creative styles. Mutual understanding of both organizations on the same content is the guarantee of impactful success at the end`,
  // },
  {
    partnerName: "SAM Global University",
    partnerLogo: SAMLogo,
    partnerThumb: SAMThumb,
    description: `Established in 2019 under Shri Guru Hargobind Society and approved by Madhya Pradesh state and UGC, SAM Global University is among the top private universities in MP.`,
  },
  // {
  //   partnerName: "SAM Global University",
  //   partnerLogo: SAMLogo,
  //   partnerThumb: SAMThumb2,
  //   description: `SAM Global University (SGU) has been constituted wide notification of M.P. State official Extraordinary Gazette Notification No. 314 dated 14 August 2019 established as per The Madhya Pradesh Niji Vishwavidyalaya (SthapanaAvamSanchalan) Adhiniyam, 2007 and Madhya Pradesh Niji Vishwavidyalaya (SthapanaAvamSanchalan) SanshodhanAdhiniyam 2019.`,
  // },
  {
    partnerName: "MGI (Modern Group of Institutions)",
    partnerLogo: ModernLogo,
    partnerThumb: ModernThumb,
    description: `MGI was established in 2007 to provide education in pharmacy, management, and commerce, founded by Late Shri P.C. Kharia.`,
  },
  {
    partnerName: "Sushant University (Erstwhile Ansal University)",
    partnerLogo: SushantLogo,
    partnerThumb: SushantThumb,
    description: `Sushant University, founded in 2012 under the Haryana Private Universities Act, is located in Gurugram and offers programs in Architecture, Design, Law, Management, Engineering, Health Sciences, Hospitality, and Planning.`,
  },
  {
    partnerName: "Shobhit University",
    partnerLogo: ShobitLogo,
    partnerThumb: ShobitThumb,
    description: `Shobhit University emphasizes strategic growth to impart quality education through vertical and horizontal integration, aspiring to become a global-className university.`,
  },
  {
    partnerName: "TruScholar",
    partnerLogo: TruscholarLogo,
    partnerThumb: TruscholarThumb,
    description: `TruScholar empowers global institutions with secure infrastructure for tamper-proof digital credentials, certificates, and badges.`,
  },
  // {
  //   partnerName: "TruScholar",
  //   partnerLogo: TruscholarLogo,
  //   partnerThumb: TruscholarThumb2,
  //   description: `Digital credentials are designed to comply with NEP2020, making it easier for universities to align with the latest educational standards.`,
  // },
  {
    partnerName: "University of Science & Technology Meghalaya (USTM)",
    partnerLogo: USTMLogo,
    partnerThumb: USTMThumb,
    description: `USTM is the first state-private science‑technology university in Northeast India and earned an “A Grade” accreditation from NAAC in 2021.`,
  },
  {
    partnerName: "Funds And Toil",
    partnerLogo: FundCorpsLogo,
    partnerThumb: FundCorpsThumb,
    description: `Founded in 2015, Funds And Toil is a management consulting firm supporting entrepreneurs through strategic advisory, network, and impact-capital.`,
  },
  {
    partnerName: "Sri Sri University",
    partnerLogo: SriSriLogo,
    partnerThumb: SriSriThumb,
    description: `Sri Sri University was officially notified in February 2012 by the Odisha government after clearing an HPC for infrastructure, academic, regulatory, and financial preparedness.`,
  },
  // {
  //   partnerName: "Sri Sri University",
  //   partnerLogo: SriSriLogo,
  //   partnerThumb: SriSriThumb2,
  //   description: `The university offers a unique education that brings together the best of Western innovation with the ancient values and wisdom of the East.`,
  // },
  {
    partnerName: "Cybermotion Technologies",
    partnerLogo: CybermotionLogo,
    partnerThumb: CybermotionThumb,
    description: `Cybermotion Technologies Pvt. Ltd. is a 30‑year‑old company working with academic institutions, DRDO, CSIR labs, and industry in electronics system design, automation, and controls.`,
  },
  {
    partnerName: "RUSHFORD Business School",
    partnerLogo: rushfordLogo,
    partnerThumb: rushfordThumb,
    description: `ISBM University and RUSHFORD Business School (Switzerland | Germany) collaborate for academic, scientific, technical cooperation, and dual‑degree programs in Business, Analytics, AI for Robotics, and Hospitality.`,
  },
  {
    partnerName: "Henry Harvin",
    partnerLogo: henryLogo,
    partnerThumb: henryThumb,
    description: `ISBM University signed an MoU with Henry Harvin®, a global Edtech company in India & US, to conduct training and placement programs across 600+ courses like Six Sigma, Tableau, Python/R Analytics, Blockchain, and Data Science.`,
  },
  {
    partnerName: "Shri Ramswaroop Memorial University",
    partnerLogo: ShriRamLogo,
    partnerThumb: ShriRamThumb,
    description: `Our journey began in 1999, with just 22 students and an unwavering commitment to quality education.`,
  },
  {
    partnerName: "Nims University Rajasthan",
    partnerLogo: NIMSLogo,
    partnerThumb: NIMSThumb,
    description: `Nims University Rajasthan, Jaipur, One of the Leading Universities in India and a Largest self-financed university in Rajasthan, is structured as a composite model university.`,
  },
  {
    partnerName: "RVS College of Arts and Science",
    partnerLogo: RVSLogo,
    partnerThumb: RVSThumb,
    description: `RVS College of Arts and Science, affiliated to Bharathiar University, Coimbatore, offer career-oriented education leading to graduation, post-graduation and research degrees in Arts and Science disciplines.`,
  },
  {
    partnerName: "K.S.Rangasamy College of Technology",
    partnerLogo: KsRnagaLogo,
    partnerThumb: KsRangaThumb,
    description: `K.S. Rangasamy College of Technology (KSRCT) was established in 1994 and is located on a scenic campus near Tiruchengode, Tamil Nadu.`,
  },
  {
    partnerName: "LNCT Group",
    partnerLogo: LNCTLogo,
    partnerThumb: LNCTThumb,
    description: `Born in semi urban city of Bilaspur (C.G.),Shri Jai Narayan Chouksey, completed his post graduation from Robertson College, Jabalpur.`,
  },
  {
    partnerName: "Jai Narain College of Technology",
    partnerLogo: JNCTLogo,
    partnerThumb: JNCTThumb,
    description: `Jai Narain College of Technology (JNCT), Bhopal, is considered to be unique in engineering education as it is firmly rooted in local soil and capable of articulating Indian ethos`,
  },
  {
    partnerName: "K.S. Rangasamy College of Arts and Science",
    partnerLogo: KsRnagaASLogo,
    partnerThumb: KsRnagaASThumb,
    description: `K.S. Rangasamy College of Arts and Science, established in 1995, stands as a pillar of academic brilliance, offering a transformative educational journey that seamlessly integrates knowledge, innovation, and ethical values.`,
  },
  {
    partnerName: "Electronics Sector Skills Council of India (ESSCI)",
    partnerLogo: ElecLogo,
    partnerThumb: ElecThumb,
    description: `The Electronics Sector Skills Council of India (ESSCI), an organization setup to provide a skilled workforce for the ESDM (Electronics System Design & Manufacturing) Industry, ESSCI is a strong contributor to fulfil the skill needs of the vibrant ESDM sector in India.`,
  },
  {
    partnerName: "Image Engineering and Technical Institute",
    partnerLogo: ImageLogo,
    partnerThumb: ImageThumb,
    description: `Image Engineering and Technical Institute (IETI) is an engineering college located in Matar, Kheda, Gujarat.`,
  },
  {
    partnerName: "D Y Patil International University",
    partnerLogo: DyPatilLogo,
    partnerThumb: DyPatilThumb,
    description: `D. Y. Patil International University, Akurdi, Pune (DYPIU) has recently become operational as a State Private University and has rolled out with a fundamental mission of covering a remarkable milestone in the history of Higher Education in India.`,
  },
  {
    partnerName: "Assam down town University",
    partnerLogo: ASSAMLogo,
    partnerThumb: ASSAMThumb,
    description: `Assam down town University has been a pioneer of modern global education that inspires its students to think.`,
  },
  {
    partnerName: "Bharatiya Engineering Science & Technology",
    partnerLogo: BharitiyaLogo,
    partnerThumb: BharitiyaThumb,
    description: `Welcome to your innovation haven, founded in 2018 and nestled across a vast expanse of 147 acres, our university thrives amidst the serenity of farm landscapes. `,
  },
  {
    partnerName: "Ajeenkya DY Patil University",
    partnerLogo: AjeeLogo,
    partnerThumb: AjeeThumb,
    description: `Ajeenkya DY Patil University (ADYPU), known for its strong emphasis on innovation, is a renowned hub for young learners with entrepreneurial aspirations.`,
  },
  {
    partnerName: "AKS University Satna",
    partnerLogo: AKSLogo,
    partnerThumb: AKSThumb,
    description: `AKS University Satna, promoted by the eminent Rajiv Gandhi Group of Institutions and value-driven professionals with an enviable track record of molding almost 50000 students over the last 28 years, is guided by Think Global and Act Local principles.`,
  },
  {
    partnerName: "Arya College of Pharmacy",
    partnerLogo: AryaLogo,
    partnerThumb: AryaThumb1,
    description: `Arya college of Pharmacy was established in year 2004, keeping in view the real need for professionally trained personnel in the fast growing pharmaceutical Industry.`,
  },
  {
    partnerName: "Automotive Skill Development Council",
    partnerLogo: ASDCLogo,
    partnerThumb: ASDCThumb,
    description: `The automotive industry in India is undergoing a transformation because of its sustained growth and profitability.`,
  },
];

const MOUs = () => {
  return (
    <>
      <title>MoUs & Collaborations | ISBM University Academic Alliances</title>
      <meta
        name="description"
        content="Explore ISBM University’s MoUs & collaborations—academic, industry & global alliances that enhance learning, research & student exposure."
      />
      <link
        rel="canonical"
        href="https://isbmuniversity.edu.in/pay-fees-online"
      />
      <meta
        name="SearchEngines"
        content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
      />
      <meta name="Robots" content="INDEX, FOLLOW" />
      <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
      <meta name="Robots" content="INDEX,ALL" />
      <meta name="YahooSeeker" content="INDEX, FOLLOW" />
      <meta name="msnbot" content="INDEX, FOLLOW" />
      <meta name="googlebot" content="Default, follow" />
      <meta name="owner" content="isbmuniversity.edu.in/" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="2 days" />
      <meta
        property="og:title"
        content="ISBM University: Strengthen through MOU's & Collaborations"
      />
      <meta
        property="og:description"
        content="Discover ISBM University MOUs and collaborations, fostering innovation & academic excellence through dynamic partnerships across diverse fields and industries."
      />
      <meta
        property="og:url"
        content="https://isbmuniversity.edu.in/pay-fees-online/"
      />
      <meta
        property="og:image"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta property="og:image:alt" content="ISBM University" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ISBM University" />
      <meta
        name="twitter:title"
        content="ISBM University: Strengthen through MOU's & Collaborations"
      />
      <meta
        name="twitter:description"
        content="Discover ISBM University MOUs and collaborations, fostering innovation & academic excellence through dynamic partnerships across diverse fields and industries."
      />
      <meta
        name="twitter:image:src"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@ISBMUniversity" />
      <meta name="twitter:creator" content="@ISBMUniversity" />
      <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
      <meta property="twitter:account_id" content="758619542734053376" />
      <meta
        name="keywords"
        content="Exchange Programs , Academic Partners , Undergraduate Courses"
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>MOU's and Collaborations</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  MOU's and Collaborations
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          {/* About SWAYAM Section */}
          <Row className="justify-content-center mb-5">
            <Row>
              <Col lg={12}>
                <ul className="mou" style={{ paddingLeft: 0 }}>
                  {mouList.map((mou, index) => (
                    <li key={index} className="d-flex flex-wrap">
                      <div className="col-lg-2 col-md-6 col-sm-6 mou-img">
                        <img
                          src={logo}
                          alt="ISBM University Logo"
                          loading="lazy"
                        />
                      </div>
                      <div className="col-lg-2 col-md-6 col-sm-6 mou-img">
                        <img
                          src={mou.partnerLogo}
                          alt={`${mou.partnerName} Logo`}
                          loading="lazy"
                        />
                      </div>
                      <div className="col-lg-8 col-md-12 col-sm-12">
                        <div className="aboutMou">
                          <p className="col-lg-10 col-md-10 col-sm-12 pe-2">
                            {mou.description}
                          </p>
                          <a
                            href={mou.partnerThumb}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="col-lg-2 col-md-2 col-sm-12"
                          >
                            <img
                              src={mou.partnerThumb}
                              alt={`${mou.partnerName} Thumbnail`}
                              loading="lazy"
                            />
                          </a>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default MOUs;
